module.exports = __webpack_public_path__ + "img/monkey.52154fc4.png";